// CSS Modules - component class name prefix: SubPage__

<template>
  <div class="SubPage__container">
    <PageHeader />
    <div class="SubPage__contentGrid SubPage__firstGrid">
      <Breadcrumbs :crumbs="crumbs" />
      <div class="SubPage__header columns is-mobile">
        <div class="column">
          <h1 class="SubPage__title">Suchergebnisse</h1>
        </div>
      </div>
    </div>
    <ResultList :config="searchConfig" />
    <Footer />
  </div>
</template>

<script>
import Breadcrumbs from "../Breadcrumbs/Breadcrumbs";
import Footer from "../Footer/Footer";
import PageHeader from "../PageHeader/PageHeader";
import ResultList from "../ResultList/ResultList";

export default {
  name: "SearchResultsPage",
  components: {
    Breadcrumbs,
    Footer,
    PageHeader,
    ResultList
  },
  data() {
    return {
      crumbs: [
        {
          title: "Startseite",
          url: "#"
        },
        {
          title: "Suche",
          url: "#"
        }
      ],
      searchConfig: {
        submitUrl: "",
        placeholder: "Suche",
        hintPrefix: "Hinweis",
        hintArticle: "ist eine Standardartikelnummer des WIKA-Typs",
        hintArticleInShop:
          "Diese Artikelnummer kann im WIKA Online-Shop bestellt werden.",
        textPrefix: "Suchinformation",
        text:
          "Geben Sie im Textfeld Ihre Suchanfrage mit <strong>mindestens zwei Zeichen</strong> ein und bestätigen Sie diese mit dem Lupensymbol bzw. der &quot;Enter&quot;-Taste. Um weiterführende Suchtipps zu erhalten, berühren Sie einfach mit Ihrem Mauszeiger das Fragezeichen-Symbol.",
        resultsText:
          "Die folgenden {{result}} Ergebnisse entsprechen Ihrer Suchanfrage",
        filterResetText: "Auswahl zurücksetzen",
        webBaseUrl: "http://www-qa.wika.dev.intern.etecture.de",
        shopBaseUrl: "http://shop-qa.wika.dev.intern.etecture.de"
      }
    };
  }
};
</script>
